export default {
  serverOffline: 'عدم ارتباط با سرور!'
}
